import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseField = _resolveComponent("BaseField")!

  return (_openBlock(), _createBlock(_component_BaseField, {
    "label-style": _ctx.labelStyle,
    "label-square": _ctx.labelSquare,
    "label-top": _ctx.labelTop,
    "label-class": _ctx.labelClass,
    attr: _ctx.attr,
    form: _ctx.form,
    type: _ctx.inputType,
    "data-type": _ctx.dataType,
    label: _ctx.label,
    "input-value": _ctx.inputValue,
    "inner-input": _ctx.innerInput,
    "input-style": _ctx.inputStyle,
    "inner-input-position": _ctx.innerInputPosition,
    step: _ctx.step,
    min: _ctx.min,
    max: _ctx.max,
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleChangeInput($event)))
  }, null, 8, ["label-style", "label-square", "label-top", "label-class", "attr", "form", "type", "data-type", "label", "input-value", "inner-input", "input-style", "inner-input-position", "step", "min", "max"]))
}